module.exports = __webpack_public_path__ + "static/media/simple-pendulum.519c48d1.mp4";